import { render, staticRenderFns } from "./GrowthCard.vue?vue&type=template&id=115ac36c&"
import script from "./GrowthCard.vue?vue&type=script&lang=js&"
export * from "./GrowthCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports